module.exports = __webpack_public_path__ + "img/deux-battants.27fd946.svg";